module.exports = __webpack_public_path__ + "img/小雨.3df72cf7.png";